import _ from 'lodash'

const getCreditStatusColor = (credit) => {
  let color = ""

  if (_.inRange(credit, 0, 5)) {
    color = "red"
  } else if (_.inRange(credit, 5, 10)) {
    color = "orange"
  } else if (_.inRange(credit, 10, 20)) {
    color = "olive"
  } else if (credit >= 20) {
    color ="green"
  }

  return color
}

export default getCreditStatusColor


// WEBPACK FOOTER //
// ./src/helpers/CreditStatus.js